import { LazyLoad } from '@petconsole/pure-fe-mui';

const Shop = LazyLoad(() => import('./Shop'));
const Shops = LazyLoad(() => import('./Shops'));

export { Shop, Shops };
